export default {"src":"/_next/static/media/security.e59c46dd.svg","height":761,"width":937,"blurWidth":0,"blurHeight":0};